module.exports = __webpack_public_path__ + "static/img/feature.655a6ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/feature.png
// module id = tXiw
// module chunks = 0